import { createDynamicSlice } from ".";
import { getBlockedDateThunk } from "../thunks/expenseCalendarControlsThunk";

export const expenseCalendarControlsSlice = createDynamicSlice({
  name: "expenseCalendarControls",
  thunk: getBlockedDateThunk,
  listMode: true,
  resetActionName: "resetExpenseCalendarControls",
});

export const expenseCalendarControlsReducer =
  expenseCalendarControlsSlice.reducer;
export const { resetExpenseCalendarControls } =
  expenseCalendarControlsSlice.actions;
